export default async function (nextId, attribute) {
  // nextId()
  // can return object like { identifier: ..., name: ... }
  // name is not mandatory
  return null
}
